import { createAsyncThunk } from '@reduxjs/toolkit';
import { JobParams } from './Job.type';
import jobService from './Job.service';

export const getJobListThunk = createAsyncThunk(
  'job/getJobListThunk',
  async (params: JobParams, thunkApi) => {
    const response = await jobService.getList(params);
    return response.data;
  },
);
export const getJobTypesListThunk = createAsyncThunk(
  'job/getJobTypesListThunk',
  async (ids: any, thunkApi) => {
    const response = await jobService.getTypes({ ids });
    return response.data;
  },
);
